// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"lw-z","badgeLink":"mw-z","category":"nw-z"};